import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { API } from "@/lib/api";

const SESSION_KEY = "ji_traffic_sess";

const getSessionId = () => {
  try {
    let s = localStorage.getItem(SESSION_KEY);
    if (!s) {
      s = `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
      localStorage.setItem(SESSION_KEY, s);
    }
    return s;
  } catch {
    return `anon-${Math.random().toString(36).slice(2, 10)}`;
  }
};

const post = (payload) => {
  try {
    const url = `${API}/traffic/track`;
    const body = JSON.stringify(payload);
    // Prefer sendBeacon for zero-latency unload safety
    if (typeof navigator !== "undefined" && navigator.sendBeacon) {
      const blob = new Blob([body], { type: "application/json" });
      const ok = navigator.sendBeacon(url, blob);
      if (ok) return;
    }
    fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body,
      credentials: "omit",
      keepalive: true,
    }).catch(() => {});
  } catch {
    /* tracking is best-effort */
  }
};

/**
 * Fires a `pageview` event on every route change.
 * Skips /admin and /login (owner traffic shouldn't skew analytics).
 */
export const useTrafficTracker = () => {
  const location = useLocation();
  useEffect(() => {
    const path = location.pathname || "/";
    if (path.startsWith("/admin") || path.startsWith("/login")) return;
    post({
      session_id: getSessionId(),
      path,
      event_type: "pageview",
      referrer: typeof document !== "undefined" ? document.referrer : null,
    });
  }, [location.pathname]);
};

/** Public helper — fire a `submit` event from any form. */
export const trackFormSubmit = (formId) => {
  post({
    session_id: getSessionId(),
    path: typeof window !== "undefined" ? window.location.pathname : "/",
    event_type: "submit",
    form_id: formId,
  });
};
